import { ComponentType, FC } from "react";
//Home Page
import Home from "../pages/Home";
//student SubMenu Pages
// Pages
//ContactUs Pages
import ContactUs from "../pages/ContactUs";
//error Pages
import PageNotFound from "../pages/error-page/PageNotFound";
import { policyRoutes } from "./policyRoutes";
import { aboutRoutes } from "./aboutRoutes";
import { courseRoutes } from "./courseRoutes";
import { admissionRoutes } from "./admissionRoutes";
import { facilitiesRoutes } from "./facilityRoutes";
import { academicRoutes } from "./academicRoutes";
import { facultyRoutes } from "./facultyRoutes";
import { studentsCornerRoutes } from "./studentCornerRoutes";
import { eventsRoutes } from "./eventRoutes";
import { muhsRoutes } from "./muhsRoutes";
import { researchRoutes } from "./researchRoutes";
import { departmentRoutes } from "./departmentRoutes";

// RouteItem is an interface for defining the application routes and navigation menu items
export interface RouteItem {
  key: string;
  title: string;
  tooltip: string;
  path: string;
  component?: FC;
  enabled: boolean;
  icon?: ComponentType;
  subRoutes?: Array<RouteItem>;
  appendDivider?: boolean;
  showInHeader?: Boolean;
}

export const routes: Array<RouteItem> = [
  //error page route
  {
    key: "router-error",
    title: "Error",
    tooltip: "Page Not Found",
    path: "*",
    enabled: true,
    component: PageNotFound,
    appendDivider: true,
    showInHeader: false,
  },
  //home page route
  {
    key: "router-home",
    title: "HOME",
    tooltip: "Home",
    path: "/",
    enabled: true,
    component: Home,
    appendDivider: true,
    showInHeader: true,
  },
  //policy page route
  policyRoutes,
  // Department page routes
  departmentRoutes,
  //about page route
  aboutRoutes,
  //course page route
  courseRoutes,
  //admission page routes
  admissionRoutes,
  //facilites page routes
  facilitiesRoutes,
  //academics page route
  academicRoutes,
  //faculty page route
  facultyRoutes,
  //studentcorner page route
  studentsCornerRoutes,
  //research page route
  researchRoutes,
  // {
  //   key: "router-research",
  //   title: "Research",
  //   tooltip: "Research",
  //   path: "/research",
  //   enabled: true,
  //   appendDivider: true,
  //   component: PageUnderConstruction,
  // },
  // event page route
  eventsRoutes,
  //muhs routes
  muhsRoutes,
  //contact us route
  {
    key: "router-contact-us",
    title: "CONTACT US",
    tooltip: "Contact Us",
    path: "/contact",
    enabled: true,
    component: ContactUs,
    appendDivider: true,
    showInHeader: true,
  },
];
export default RouteItem;
